import React, { Component } from 'react';
import gripList from '../../data/grip';
import GripBanner from "./GripBanner";
import ReactGA from "react-ga";

class GripPage extends Component {
	constructor(props) {
		super(props);
		this.state = gripList;
	}


	render() {
		ReactGA.pageview(window.location.pathname + window.location.search);
		const serviceItems = this.state.serviceList.map((item) => {
			return (
				<div key={item.id} className="col-lg-6 col-sm-6 col-md-6">
					{/*<FeatureItem key={item.id} heading={item.heading} info={item.info} imgUrl={item.imgUrl} />*/}
					<div className="single-features">
						<div className="features-icon d-flex align-items-center justify-content-center">
							<img
								src={item.imgUrl}
								alt=""
								className="animate"
								data-animate="rubberBand"
								data-duration="1s"
								data-delay="0.1s"
							/>
						</div>
						<div className="features-content">
							<h4>{item.heading}</h4>
							<div className="animate" data-animate="fadeIn" data-duration="1s" data-delay="0.2s">
								<p>{item.info}</p>
							</div>
						</div>
					</div>
				</div>
			);
		});

		return (
			<main className={'grip-page'}>

			<GripBanner />

			<section className="service-area relative mt-50 mb-50">
				<div className="container">
					<div className="row align-items-center">
						<div className="col-lg-5">
							<div
								className="service-left animate"
								data-animate="fadeIn"
								data-duration="1.5s"
								data-delay="0.2s"
							>
								<img className="img-fluid " src={require('../../assets/img/img_grip.png')} alt="" />
							</div>
						</div>
						<div className="col-lg-7">
							<div className="service-right">
								<div className="row">{serviceItems}</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			</main>
		);
	}
}

export default GripPage;
